__turbopack_context__.v({
  "accessoriesSection": "applied-accessories-section-module-scss-module__Bv2ZCa__accessoriesSection",
  "benefitBadge": "applied-accessories-section-module-scss-module__Bv2ZCa__benefitBadge",
  "benefitText": "applied-accessories-section-module-scss-module__Bv2ZCa__benefitText",
});
